export class EnderecoPessoa {
    constructor({
        uf,
        cidade,
    }) {
      this.cidade = cidade ? cidade : null;
      this.uf = uf ? uf : null;
    }
  }
  